/**
 * @desc selectAxios 代理
 * @file selectAxios.js
 * @author baibangyi(baibangyi@baidu.com)
 */

import $http from './ajax';
import Vue from 'vue';

let selectAxios = {};

function selectAjax(options = {}) {
    const ErrorMsg = {
        ERROR_ILLEGAL_ARGS: 102,
        ERROR_ILLEGAL_ARGS_MSG: '参数不符合要求',
        ERROR_RUN_FAILED: 103,
        ERROR_RUN_FAILED_MSG: '接口运行出错',
        ERROR_WRONG_NETWORK: 104,
        ERROR_WRONG_NETWORK_MSG: '网络错误',
        ERROR_WRONG_JUMP: 105,
        ERROR_WRONG_JUMP_MSG: '页面跳转失败'
    };

    const resultInfo = {
        isSuccess: 0, // 0 表示成功 1表示失败
        msg: '' // 具体信息
    };

    return new Promise((resolve, reject) => {
        let result = {
            status: 0,
            data: {},
            msg: ''
        };
        if (!options.url) {
            return;
        }
        // 判断是否是线上环境
        if (process.env.NODE_ENV === 'production') {
            let reqOptions = {
                ...options
            };
            if (!options.isAjax) {
                // data 模式
                if (Object.prototype.toString.call(options.data) === '[object Object]'
                    && options.method === 'POST'
                ) {
                    reqOptions.data = {
                        ...options,
                        // 后端只取 params，兼容
                        params: JSON.stringify(options.data)
                    };
                }
                // get 模式
                else {
                    reqOptions.params = options;
                }
                // 请求代理接口
                reqOptions.url = '/mp/front/midproxy';
            }
            else {
                // 直接请求，跨域访问设置
                reqOptions.withCredentials = true;
            }
            $http(reqOptions).then(res => {
                // ajax 模式，直接透传
                if (options.isAjax) {
                    resolve(res);
                }
                else {
                    // 如果返回状态正常，返回数据
                    result.status = resultInfo.isSuccess;
                    result.data = res.data.data;
                    resolve(result);
                }
            }).catch(err => {
                // ajax 模式，直接透传
                if (options.isAjax) {
                    reject(err);
                }
                else {
                    result.status = !resultInfo.isSuccess;
                    result.msg = err.data && err.data.msg || ErrorMsg.ERROR_WRONG_NETWORK_MSG;
                    reject(result);
                }
            });
        }
        else {
            // url可能为ral内部格式 passport:/get/info
            options.url = options.url.split(':').length > 1
                // 如果带了 `:`，则切掉 `:` 之前的 ral 配置
                ? options.url.split(':')[1]
                // 否则就取自己
                : options.url.split(':')[0];
            $http(options).then(res => {
                result.status = resultInfo.isSuccess;
                result.data = res.data;
                resolve(result);
            }).catch(err => {
                result.status = !resultInfo.isSuccess;
                result.msg = err.msg || ErrorMsg.ERROR_WRONG_NETWORK_MSG;
                reject(result);
            });
        }
    });
}

function selectAxiosPost(url, options = {}) {
    options.url = url;
    if (options.url && Object.prototype.toString.call(options.url) === '[object String]') {
        options.method = 'POST';
        options.headers = options.headers || {
            'Content-Type': 'application/x-www-form-urlencoded'
        };
        return this.selectAjax(options);
    }
    return '参数不符合要求';
}

function selectAxiosGet(url, options = {}) {
    options.url = url;
    if (options.url && Object.prototype.toString.call(options.url) === '[object String]') {
        options.method = 'GET';
        options.headers = options.headers || this.headers;
        return this.selectAjax(options);
    }
    return '参数不符合要求';
}
selectAxios = {
    selectAjax,
    selectAxiosPost,
    selectAxiosGet
};

Vue.prototype.$selectAxios = selectAxios;

export default selectAxios;
